// App Routes Constants
export const APP_ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  MODULES: '/modules',
  CREATE_PASSWORD: '/create-password',
  FORGOT_PASSWORD: '/forgot-password',
  VERIFY_CODE: '/verify-code',
  RESET_PASSWORD: '/reset-password',
  DASHBOARD: '/dashboard',
  ACCOUNTS: '/accounts',
  TRANSACTIONS: '/transactions',
  CUSTOMERS: '/customers',
  ONBOARDING: '/onboarding',
  ACCESS_MANAGEMENT: '/access-management',
  COMPLIANCE: '/compliance',
  SETTINGS: '/settings',
} as const;
